/**
 * Caching for /cached pages. Use label ID as key, put static response behind it
 * Example:
 * 231: {...}
 */

export default {};
